/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Theme from '@nmx/template/dist/componentLibrary/Theme';
// native components
import FinancialPlanningSection1 from './components/financialPlanningSection1';
import FinancialPlanningSection2 from './components/financialPlanningSection2';
import GenericFafa from './components/genericFafa';
import HeroSection from './components/heroSection';
import IntroSection from './components/introSection';
import Metadata from './components/metadata';
import Testimonial from './components/testimonials';
import UnderstandingProduct from './components/understandingProduct';
// images
import highResDesktopImage from './components/heroSection/images/default-career-changers-desktop.webp';
import highResMobileImage from './components/heroSection/images/default-career-changers-mobile.webp';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      config={config}
      dynamicConfig={dynamicConfig}
      useReCaptcha={false}
      disableDisclaimerTopBorder
      customDisclaimers={[
        <>
          Successful candidates will begin as financial representatives. Financial Representatives are prohibited from using the title &#34;Advisor&#34; until licensures are obtained (including SIE 6 and 63) and Northwestern Mutual specified courses are satisfactorily completed.
        </>,
        <>
          This material is intended to show the potential of the career and shall in no way be construed as contractual obligations by the network office or The Northwestern Mutual Life Insurance Company. Northwestern Mutual Financial Representatives are Independent Contractors whose income is based solely on production. Commissions, fees, and bonuses are subject to change.
        </>,
      ]}>

      <Head>
        {/* prefetch expensive images */}
        <link rel='preload' href={highResMobileImage} as='image' media={`(max-width: ${Theme.breakpoints.values.medium}px)`} />
        <link rel='preload' href={highResDesktopImage} as='image' media={`(min-width: ${Theme.breakpoints.values.medium + 1}px)`} />
      </Head>

      <Metadata
        image={highResDesktopImage}
        pageDescription={pageProps.pageDescription}
        pageTitle={pageProps.pageTitle}
      />

      <HeroSection careersFormLink={pageProps.thisCareersFormLink} />

      <IntroSection />

      <FinancialPlanningSection1 />

      <UnderstandingProduct />

      <Testimonial />

      <FinancialPlanningSection2 />

      <GenericFafa careersFormLink={pageProps.thisCareersFormLink} />

    </Page>
  );
};
